export default function noop (d) {
  console.trace('Noop Called', d);
  return d;
}
